module.exports = __webpack_public_path__ + "media/images/flags/32/Kazakhstan-404e973b8e736e5339e7a0c63150298f.png";